import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

function BatchSearchProgressModalFooter(props) {
  const { cancelSearch } = props;

  return (
    <div className="batch-search-modal__footer">
      <ButtonWithIcon
        data-e2e="batch-modal-search-cancel"
        type="link"
        size="small"
        linkIconSize="s"
        sprite="Close"
        iconRight
        onClick={cancelSearch}
        className="e2e-batch-modal-search-cancel">
        Cancel
      </ButtonWithIcon>
    </div>
  );
}

BatchSearchProgressModalFooter.propTypes = {
  cancelSearch: PropTypes.func.isRequired,
};

export default BatchSearchProgressModalFooter;
